import * as React from 'react';

const DropBig = ({ ...props }) => (
    <svg
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7.5 17L3.60289 10.25L11.3971 10.25L7.5 17Z"
            fill="currentColor"
        />
    </svg>
);

export default DropBig;
